<template>
  <svg
    width="18px"
    height="22px"
    viewBox="0 0 18 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="00-Framework" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Framework" transform="translate(-1294.000000, -444.000000)" fill="currentColor">
        <g id="typo" transform="translate(347.000000, 303.000000)">
          <g id="Group-3" transform="translate(-0.000000, -0.000000)">
            <g id="Presets" transform="translate(944.000000, 14.000000)">
              <g id="preis" transform="translate(0.000000, 126.000000)">
                <g id="Tools-/-Technology-/-calculator-/-24">
                  <path
                    d="M19.5,3 L19.5,21 L4.5,21 L4.5,3 L19.5,3 L19.5,3 Z M19.5,1.5 L4.5,1.5 C3.67157288,1.5 3,2.17157288 3,3 L3,21 C3,21.8284271 3.67157288,22.5 4.5,22.5 L19.5,22.5 C20.3284271,22.5 21,21.8284271 21,21 L21,3 C21,2.17157288 20.3284271,1.5 19.5,1.5 Z M6.75,17.25 L8.25,17.25 L8.25,18.75 L6.75,18.75 L6.75,17.25 Z M15.75,17.25 L17.25,17.25 L17.25,18.75 L15.75,18.75 L15.75,17.25 Z M6.75,13.5 L8.25,13.5 L8.25,15 L6.75,15 L6.75,13.5 Z M15.75,13.5 L17.25,13.5 L17.25,15 L15.75,15 L15.75,13.5 Z M6.75,9.75 L8.25,9.75 L8.25,11.25 L6.75,11.25 L6.75,9.75 Z M11.25,17.25 L12.75,17.25 L12.75,18.75 L11.25,18.75 L11.25,17.25 Z M11.25,13.5 L12.75,13.5 L12.75,15 L11.25,15 L11.25,13.5 Z M11.25,9.75 L12.75,9.75 L12.75,11.25 L11.25,11.25 L11.25,9.75 Z M15.75,9.75 L17.25,9.75 L17.25,11.25 L15.75,11.25 L15.75,9.75 Z M6.75,5.25 L17.25,5.25 L17.25,7.5 L6.75,7.5 L6.75,5.25 Z"
                    id="Fill"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Plus'
};
</script>
